var map = {
	"./ebirah_full.png": 2830,
	"./ebirah_game.png": 9792,
	"./ebirah_moves.png": 9153,
	"./ebirah_side.png": 9356,
	"./general_game.png": 3314,
	"./general_side.png": 9484,
	"./giant_squid_full.png": 9308,
	"./giant_squid_game.png": 1492,
	"./giant_squid_moves.png": 8172,
	"./giant_squid_side.png": 5676,
	"./jormungandr_full.png": 3804,
	"./jormungandr_game.png": 9580,
	"./jormungandr_moves.png": 8259,
	"./jormungandr_side.png": 9730,
	"./kraken_full.png": 7864,
	"./kraken_game.png": 1369,
	"./kraken_moves.png": 9932,
	"./kraken_side.png": 2974,
	"./leviathan_full.png": 6977,
	"./leviathan_game.png": 7389,
	"./leviathan_moves.png": 7979,
	"./leviathan_side.png": 5995,
	"./loch_ness_full.png": 3332,
	"./loch_ness_game.png": 6687,
	"./loch_ness_moves.png": 7352,
	"./loch_ness_side.png": 897,
	"./megalodon_full.png": 1196,
	"./megalodon_game.png": 7011,
	"./megalodon_moves.png": 9642,
	"./megalodon_side.png": 9128,
	"./sea_hydra_full.png": 4229,
	"./sea_hydra_game.png": 5359,
	"./sea_hydra_moves.png": 3683,
	"./sea_hydra_side.png": 8429,
	"./siren_full.png": 5092,
	"./siren_game.png": 8435,
	"./siren_moves.png": 343,
	"./siren_side.png": 8556,
	"./white_whale_full.png": 8301,
	"./white_whale_game.png": 4133,
	"./white_whale_moves.png": 8482,
	"./white_whale_side.png": 7958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4593;